import "./SnapWidgetPrivacyPolicy.css";

const updatedAt = "September 27, 2026";

const sections = [
  {
    title: "1. Information We Collect",
    body: [
      "When you sign in with Google, AudioSplit receives account information such as your name, email address, profile identifier, and authentication information needed to keep you signed in.",
      "When you create a demix, we process the audio or video file you select, its filename, content type, storage location, processing status, stem metadata, timestamps, and diagnostic information associated with that job.",
      "If you report an issue, we collect the description you provide together with relevant job, app-version, and processing metadata. We do not intentionally include source media or raw backend error text in an issue report."
    ]
  },
  {
    title: "2. How AudioSplit Uses Information",
    body: [
      "We use information to authenticate you, upload and process media, separate tracks into stems, synchronize job status, prepare stems for playback and download, provide support, secure the service, diagnose failures, and improve reliability.",
      "AudioSplit does not sell your personal information and does not use uploaded media to build advertising profiles."
    ]
  },
  {
    title: "3. Cloud Processing and Service Providers",
    body: [
      "AudioSplit uses Firebase Authentication, Cloud Firestore, Firebase Storage, Google Cloud Pub/Sub, and related Google infrastructure. Processing workloads may also run through BlackDoor's hosting and compute providers, including App Hosting, Northflank, and Modal.",
      "These providers process information as needed to deliver infrastructure, storage, authentication, processing, monitoring, or support services on our behalf and under their applicable terms."
    ]
  },
  {
    title: "4. Media, Stems, and Local Storage",
    body: [
      "Your selected source file is uploaded to private cloud storage for processing. Generated stems are stored for your account and downloaded to the app's private internal storage for seamless playback. Files are copied to a user-accessible location only when you choose a download action.",
      "Do not upload media unless you have the rights and permission necessary to process it."
    ]
  },
  {
    title: "5. Retention and Deletion",
    body: [
      "We retain account and demix information while your account is active and as reasonably necessary to provide the service, resolve disputes, enforce agreements, maintain security, and comply with law.",
      "You may request deletion of your account and associated demix data from the AudioSplit account screen or the public account-deletion page. Some records may be retained where required for security, fraud prevention, legal compliance, or an active dispute."
    ]
  },
  {
    title: "6. Security",
    body: [
      "We use access controls and account-scoped storage paths designed to prevent users from reading another user's source files, stems, or job records. No electronic transmission or storage system can be guaranteed to be completely secure."
    ]
  },
  {
    title: "7. Children's Privacy",
    body: [
      "AudioSplit is not directed to children under 13, and we do not knowingly collect personal information from children under 13. We prohibit any use of the service involving child sexual abuse or exploitation. Review our Child Safety Standards for more information."
    ]
  },
  {
    title: "8. Your Choices and Rights",
    body: [
      "Depending on where you live, you may have rights to access, correct, delete, restrict, or object to certain processing of your personal information. Contact us to exercise a right or ask a privacy question."
    ]
  },
  {
    title: "9. Changes and Contact",
    body: [
      "We may update this Privacy Policy as AudioSplit changes. The latest version and effective date will remain available on this page.",
      "For privacy questions or requests, contact BlackDoor at support@blackdoorapps.com."
    ]
  }
];

export default function AudioSplitPrivacyPolicy() {
  return (
    <main className="snap-policy-page">
      <section className="snap-policy-hero">
        <a className="snap-policy-brand" href="/">BlackDoor</a>
        <p className="snap-policy-kicker">AudioSplit</p>
        <h1>Privacy Policy</h1>
        <p className="snap-policy-updated">Last updated {updatedAt}</p>
        <p className="snap-policy-summary">How BlackDoor collects, uses, stores, and protects information when you use AudioSplit.</p>
      </section>
      <section className="snap-policy-content" aria-label="Privacy policy content">
        <article className="snap-policy-card snap-policy-intro"><p>By using AudioSplit, you acknowledge the practices described in this policy. If you do not agree, do not upload media or use the service.</p></article>
        {sections.map((section) => <article className="snap-policy-card" key={section.title}><h2>{section.title}</h2>{section.body.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}</article>)}
      </section>
    </main>
  );
}
